// appsActions.js
import {
  ADD_APP_TO_IFRAME,
  REMOVE_APP_FROM_IFRAME,
  SELECTED_APP_TO_IFRAME,
  UPDATE_APP_FROM_IFRAME,
  UPDATE_IFRAME_APP_URL
} from '../types/iframeConstants'

export function addAppToIframe(item) {
  return {
    type: ADD_APP_TO_IFRAME,
    payload: item
  }
}

export function selectedAppToIframe(item) {
  return {
    type: SELECTED_APP_TO_IFRAME,
    payload: item
  }
}

export function removeAppFromIframe(item) {
  return {
    type: REMOVE_APP_FROM_IFRAME,
    payload: item
  }
}

export function updateIframeApp(payload) {
  return {
    type: UPDATE_APP_FROM_IFRAME,
    payload
  }
}

export function updateIframeAppUrl(payload) {
  return {
    type: UPDATE_IFRAME_APP_URL,
    payload
  }
}
